// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zr11r4{padding-inline:var(--_1qv4hth)}\n._1q5111r4{padding-block-start:var(--_1qv4hth)}", ""]);
// Exports
module.exports = exports;
